import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import LogoSvg from "../../../assets/LogoSvg";
import { CountUp } from "../../../lib/CountUp";
import BuddibleSocket from "../../../lib/BuddibleSocket";
import Utilities from "../../../lib/Utilities";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();

let amount = {
  FCL: 0,
  FCL2: 0,
  LCL: 0,
  AIR: 0,
  TOTAL: 0,
};
let promotion_total = 0;
let promotion_list = [];
/*#3b44ac*/
export default function ScheduleCards() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLangChange, setIsLangChange] = useState(true);
  const countUpFCL = useRef();
  const countUpLCL = useRef();
  const countUpAIR = useRef();
  const { t, i18n } = useTranslation();
  let countUpAnimFCL;
  let countUpAnimLCL;
  let countUpAnimAIR;

  const onLanguageChanged = (lng) => {
    setIsLangChange((prevState) => !prevState);
    // 여기에 추가 작업 가능 (예: 날짜/시간 포맷 변경 등)
  };
  useEffect(() => {
    SELECT_SCHEDULE_AMOUNT();

    i18n.on("languageChanged", onLanguageChanged);

    return () => {
      i18n.off("languageChanged", onLanguageChanged); // clean up
    };
  }, []);

  useEffect(() => {
    if (countUpFCL.current && !isLoading) {
      initCountUpFCL();
    }
    if (countUpLCL.current && !isLoading) {
      initCountUpLCL();
    }
    if (countUpAIR.current && !isLoading) {
      initCountUpAIR();
    }
  }, [isLoading, isLangChange]);

  //스케줄 개수 받아오기
  function SELECT_SCHEDULE_AMOUNT() {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_schedule_count_select.php",
      msgID: msgID,
      data: {},
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          amount = { ...newData["returnData"][0] };
          SELECT_PROMOTION_SCHEDULE_AMOUNT();
        }
      }
    });
  }

  function SELECT_PROMOTION_SCHEDULE_AMOUNT() {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_schedule_promotion_by_main_select.php",
      msgID: msgID,
      data: {},
      skip: 0,
      page: 1,
      take: 6,
      sp_DISPLAY: 0,
      sm_USE_YN: "Y",
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          promotion_list = [...newData["returnData"]];
          promotion_total = parseInt(newData.pageSize, 10);
          setIsLoading(false);
        }
      }
    });
  }

  async function initCountUpFCL() {
    countUpAnimFCL = new CountUp(
      countUpFCL.current,
      parseInt(amount.FCL, 10) + parseInt(amount.FCL2, 10)
    );

    if (!countUpAnimFCL.error) {
      countUpAnimFCL.start();
    } else {
      console.error(countUpAnimFCL.error);
    }
  }

  async function initCountUpLCL() {
    countUpAnimLCL = new CountUp(countUpLCL.current, parseInt(amount.LCL));
    if (!countUpAnimLCL.error) {
      countUpAnimLCL.start();
    } else {
      console.error(countUpAnimLCL.error);
    }
  }

  async function initCountUpAIR() {
    countUpAnimAIR = new CountUp(countUpAIR.current, parseInt(amount.AIR));
    if (!countUpAnimAIR.error) {
      countUpAnimAIR.start();
    } else {
      console.error(countUpAnimAIR.error);
    }
  }

  const scheduleCards = [
    {
      icon: "fa-solid fa-ship mr-1",
      label: t("main.scheduleCards.fcl"),
      color: "info",
      ref: countUpFCL,
      link: "/ScheduleFCL",
      state: { type: "FCL" },
    },
    {
      icon: "fa-solid fa-boxes-stacked mr-1",
      label: t("main.scheduleCards.lcl"),
      color: "info",
      ref: countUpLCL,
      link: "/ScheduleLCL",
      state: { type: "LCL" },
    },
    {
      icon: "fa-solid fa-plane-departure",
      label: t("main.scheduleCards.air"),
      color: "info",
      ref: countUpAIR,
      link: "/ScheduleAIR",
      state: { type: "AIR" },
    },
    {
      icon: "fa-solid fa-gift ml-1",
      label: t("main.scheduleCards.promotion"),
      color: "danger",
      ref: null,
      link: "/ScheduleFCL",
      state: { type: "promo" },
    },
  ];

  return (
    <div
      className="position-relative overflow-hidden"
      style={{ height: "720px" }}
    >
      <img
        src="https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/Z0001/amber.jung@buddible.com/20250813090933_container.jpg"
        alt="main"
        className="w-100 h-100 position-absolute"
      />
      <div
        className="w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center"
        style={{
          zIndex: 2,
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.2), rgba(19, 22, 56,0.4))",
        }}
      >
        <div className="container mb-3 ">
          <div className="px-3">
            <p className="h4 font-weight-bold d-flex flex-row align-items-end flex-wrap position-relative">
              <LogoSvg width="260px" color="#fff" point="#0097b7" />
            </p>
            <p className="h4 text-white font-weight-bold mb-0">
              {t("main.scheduleCards.title")}
            </p>
            <div className="d-lg-flex flex-row justify-content-between align-items-center">
              <p className="h5 text-white mb-0">
                {t("main.scheduleCards.description")}
              </p>
              <Link to="/ScheduleFCL" className="btn btn-info mt-1">
                {t("main.scheduleCards.booking")}
              </Link>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row m-0 p-0">
            {scheduleCards.map((item) => {
              return (
                <div className="col-6 col-xl-3 p-2" key={item.label}>
                  <div
                    className="p-3 shadow text-dark flex-fill position-relative h-100"
                    style={{
                      background: "rgba(255,255,255,0.85)",
                      backdropFilter: "blur(2px)",
                      borderRadius: "1.5em .5em 1.5em .5em",
                    }}
                  >
                    <div className="d-flex flex-column justify-content-between h-100">
                      <div>
                        <p className="h6 font-weight-bold">
                          <i className={item.icon} /> {item.label}
                        </p>
                        <p
                          className={`h3 font-weight-900 text-${item.color} mb-3`}
                        >
                          <span ref={item.ref}>0</span>
                          {t("main.scheduleCards.count")}
                        </p>
                      </div>
                      <div className="d-flex flex-row justify-content-end align-items-center">
                        <Link
                          className={`btn btn-sm btn-outline-${item.color}`}
                          to={item.link}
                          state={item.state}
                        >
                          {t("main.scheduleCards.search")}
                          <i className="fa-solid fa-arrow-right ml-1" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        className="position-absolute rounded-circle d-none"
        style={{
          width: "100vw",
          height: "95vw",
          zIndex: 1,
          background: "rgba(19, 22, 56, .6)",
          top: 80,
          left: "50%",
          transform: "translateX(-50%)",
        }}
      ></div>
    </div>
  );
}
